import React from "react";
import { Outlet } from "react-router-dom";
import TopBar from "./TopBar";
import BottomNav from "./BottomNav";
import WrongNetwork from "../wallet/WrongNetwork";
import { useWallet } from "../../context/WalletContext";

// The mobile frame: fixed top bar + scrolling screen + fixed bottom nav.
// Network-switch overlay sits ON TOP without unmounting screens (no refresh).
export default function AppShell() {
  const { account, isCorrectNetwork } = useWallet();
  const showWrongNet = account && !isCorrectNetwork;

  return (
    <div className="app-shell with-nav">
      <div className="ambient"><i /><i /><i /></div>
      <TopBar />
      <Outlet />
      <BottomNav />
      {showWrongNet ? <WrongNetwork /> : null}
    </div>
  );
}
